
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hashtag/[tag]",
      function () {
        return require("private-next-pages/hashtag/[tag]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hashtag/[tag]"])
      });
    }
  